export enum IPErrorMessages {
  InvalidIP = 'This is not a valid IP address',
  RequiredField = 'IP address is required',
  NoError = ''
}
